import { axiosJwt } from '@/shared/auth/axiosJwt';

const api = `${process.env.VUE_APP_API_URL}${process.env.VUE_APP_API_SOL}${process.env.VUE_APP_API_PATH}/sol`;
const urlBase = `${api}/publicoalvo`;

export default {
    obterTodos(active) {
        active == null ? active = '' : active
        return axiosJwt.get(`${urlBase}?active=${active}`);
    },
    obterPorId(id) {
        return axiosJwt.get(`${urlBase}/${id}`);
    },
    excluir(id) {
        return axiosJwt.delete(`${urlBase}/${id}`);
    },
    inserir(publicoAlvo) {
        return axiosJwt.post(`${urlBase}`, publicoAlvo);
    },
    atualizar(id, publicoAlvo) {
        return axiosJwt.put(`${urlBase}/${id}`, publicoAlvo);
    },
    obterPublicoSas() {
        return axiosJwt.get(`${api}/sas/publicos`);
    },
};